import type { Locale } from "src/lib/Intl";
import { getBaseUrl } from "src/utils/getBaseUrl";
import { toPublicAsPath } from "src/utils/pagination/page-url";

/**
 * The page's address as shoppers see it on the shop's own domain
 * (https://www.otrium.nl/dames/kleding?page=2), whatever host served it, so
 * the apps can read the shop from the domain.
 */
export function getPublicPageUrl(asPath: string, locale: Locale): string {
  return `${getBaseUrl(locale.toLowerCase())}${toPublicAsPath(asPath)}`;
}
